import {
  BulkProcessProjectTimeRecordDocument,
  BulkProcessProjectTimeRecordMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export interface IBulkProcessItemTimeRecord {
  timeRecordId?: string
  attendanceShiftId: string
  projectWorkerId?: string
  subprojectId?: string
}

export interface IBulkProcessTimeRecord {
  items: IBulkProcessItemTimeRecord[]
}

export const useBulkProcessProjectTimeRecord = () => {
  const [bulkProcessTimeRecord, { loading }] = useMutation(BulkProcessProjectTimeRecordDocument, {
    extractorFn: (data: BulkProcessProjectTimeRecordMutation) =>
      data.projectManagementMutations.bulkProcessProjectmanagementTimeRecord,
  })

  return {
    loading,
    bulkProcessProjectTimeRecord({ items }: IBulkProcessTimeRecord) {
      return bulkProcessTimeRecord({ variables: { items } })
    },
  }
}
